import React from "react";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";

const API = localStorage.getItem("assethost");

export default class UpdatePopStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      valid: false,
      msg: "",
      toastColor: "",

      // Search form fields
      searchStatus: "",
      startDate: "",
      endDate: "",

      // Search results
      popsList: [],
      showResults: false,

      // Status update modal
      showStatusModal: false,
      selectedPop: null,
      availableStatuses: [],
      selectedStatus: "",
      selectedMessage: "",

      // Pagination
      page: 0,
      size: 10,
      totalPages: 1,

      errors: {},
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleStatusUpdate = this.handleStatusUpdate.bind(this);
    this.openStatusModal = this.openStatusModal.bind(this);
    this.closeStatusModal = this.closeStatusModal.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchAvailableStatuses = this.fetchAvailableStatuses.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.fetchAvailableStatuses(token);
  }

  fetchAvailableStatuses(token) {
    axios
      .get(API + "/billing/getpopstatus", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          availableStatuses: response.data || [],
        });
      })
      .catch((error) => {
        console.error("Failed to load POP statuses:", error);
        this.setState({
          msg: "Failed to load available statuses",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    // Search validation is optional, so always valid for search
    if (s.showStatusModal) {
      if (!s.selectedStatus) {
        errors.selectedStatus = "Status selection is required";
        valid = false;
      }
      if (!s.selectedMessage || !s.selectedMessage.trim()) {
        errors.selectedMessage = "Accompanying message is required";
        valid = false;
      }
    }
    if (!s.showStatusModal) {
      if (!s.searchStatus || !s.searchStatus.trim()) {
        errors.searchStatus = "Status is required for search";
        valid = false;
      }
      if (!s.startDate) {
        errors.startDate = "Start date is required for search";
        valid = false;
      }
      if (!s.endDate) {
        errors.endDate = "End date is required for search";
        valid = false;
      }
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleSearch(e) {
    e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    if (!this.validate()) {
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    const provisionalStartDayOffset = 7;
    const searchRequest = {
      popStatus: this.state.searchStatus || null,
      startDate: this.state.startDate
        ? new Date(this.state.startDate).toISOString()
        : new Date(
            new Date().setTime(
              new Date().getTime() - provisionalStartDayOffset * 24 * 3600000
            )
          ),
      endDate: this.state.endDate
        ? new Date(this.state.endDate).toISOString()
        : new Date(),
    };

    axios
      .post(API + "/billing/getmypopsbysearch", searchRequest, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let popsList = [];
        let totalPages = 1;

        if (Array.isArray(response.data)) {
          popsList = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          popsList = response.data.content;
          totalPages = response.data.totalPages || 1;
        } else {
          popsList = [];
        }

        this.setState({
          popsList,
          totalPages,
          showResults: true,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to search POPs",
          toastColor: "danger",
          popsList: [],
          showResults: true,
        });
      });
  }

  openStatusModal(pop) {
    this.setState({
      showStatusModal: true,
      selectedPop: pop,
      selectedStatus: pop.popStatus || "",
      msg: "",
      errors: {},
    });
  }

  closeStatusModal() {
    this.setState({
      showStatusModal: false,
      selectedPop: null,
      selectedStatus: "",
      errors: {},
    });
  }

  handleStatusUpdate(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    const updateRequest = {
      id: this.state.selectedPop.id,
      companyProfileId: Number(sessionStorage.getItem("companyProfileId")) || 0,
      popStatus: this.state.selectedStatus,
      message: this.state.selectedMessage,
    };

    axios
      .post(API + "/billing/updatestatus", updateRequest, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg: response.data.message || "Status updated successfully!",
            toastColor: "success",
            loading: false,
            showStatusModal: false,
            selectedPop: null,
            selectedStatus: "",
          });

          // Refresh search results
          setTimeout(() => {
            this.handleSearch(e);
          }, 1000);
        } else {
          this.setState({
            msg: response.data.message || "Failed to update status",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to update status. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      this.setState({ page: this.state.page - 1 }, () => {
        const event = { preventDefault: () => {} };
        this.handleSearch(event);
      });
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      this.setState({ page: this.state.page + 1 }, () => {
        const event = { preventDefault: () => {} };
        this.handleSearch(event);
      });
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 d-flex flex-column flex-grow-1">
          <Banner title="Update POP Status" />
          {divMsg}
          <div className="w-100 flex-grow-1 px-5 d-flex flex-column justify-content-start">
            <div className="w-full">
              <form onSubmit={this.handleSearch} className="d-flex gap-2 mt-2">
                <div className="input-group">
                  <label className="input-group-text !w-24">Status</label>
                  <select
                    name="searchStatus"
                    className={`form-control ${
                      s.errors.searchStatus ? " !border-red-500" : ""
                    }`}
                    value={s.searchStatus}
                    onChange={this.handleChange}
                  >
                    <option value="">All Statuses</option>
                    {s.availableStatuses.map((status) => (
                      <option key={status} value={status}>
                        {status}
                      </option>
                    ))}
                  </select>
                  {s.errors.searchStatus && (
                    <span className="input-group-error">
                      {s.errors.searchStatus}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text !w-24">Start Date</label>
                  <input
                    name="startDate"
                    className={`form-control ${
                      s.errors.startDate ? " !border-red-500" : ""
                    }`}
                    type="date"
                    value={s.startDate}
                    onChange={this.handleChange}
                  />
                  {s.errors.startDate && (
                    <span className="input-group-error">
                      {s.errors.startDate}
                    </span>
                  )}
                </div>
                <div className="input-group ">
                  <label className="input-group-text !w-24">End Date</label>
                  <input
                    name="endDate"
                    className={`form-control ${
                      s.errors.endDate ? " !border-red-500" : ""
                    }`}
                    type="date"
                    value={s.endDate}
                    onChange={this.handleChange}
                  />
                  {s.errors.endDate && (
                    <span className="input-group-error">
                      {s.errors.endDate}
                    </span>
                  )}
                </div>
                <button
                  type="submit"
                  className="btn btn-primary text-nowrap"
                >
                  Search POPs
                </button>
              </form>

              {s.showResults && (
                <>
                  {s.popsList.length === 0 ? (
                    <div className="text-center py-8 text-muted mt-2">
                      No POPs found matching your search criteria
                    </div>
                  ) : (
                    <div className="w-100 overflow-auto border mt-6">
                      <table className="table table-striped table-hover rounded">
                        <thead className="table-primary">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Company Name
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              POP File ID
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Current Status
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Message
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Creation Date
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {s.popsList.map((pop, index) => (
                            <tr
                              key={pop.id || index}
                              className="hover:bg-gray-50"
                            >
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {pop.companyName || "-"}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {pop.popFileId || "-"}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                <span
                                  className={`px-2 py-1 rounded-pill text-xs fw-medium ${
                                    pop.popStatus === "APPROVED"
                                      ? "bg-success-subtle text-success"
                                      : pop.popStatus === "PENDING"
                                      ? "bg-yellow-100 text-yellow-800"
                                      : pop.popStatus === "REJECTED"
                                      ? "bg-red-100 text-red-800"
                                      : "bg-secondary-subtle text-secondary"
                                  }`}
                                >
                                  {pop.popStatus || "Unknown"}
                                </span>
                              </td>
                              <td className="px-6 py-4 text-sm text-dark">
                                {pop.message || "-"}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {pop.creationDateTime
                                  ? new Date(
                                      pop.creationDateTime
                                    ).toLocaleString()
                                  : "-"}
                              </td>
                              <td className="px-6 py-4 text-nowrap text-sm fw-medium">
                                <button
                                  className="btn btn-primary"
                                  onClick={() => this.openStatusModal(pop)}
                                >
                                  Update Status
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {s.totalPages > 1 && (
                    <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                      <button
                        className="btn btn-outline"
                        disabled={s.page === 0}
                        onClick={this.handlePreviousPage}
                      >
                        Previous
                      </button>
                      <span>
                        Page {s.page + 1} of {s.totalPages}
                      </span>
                      <button
                        className="btn btn-outline"
                        disabled={s.page + 1 >= s.totalPages}
                        onClick={this.handleNextPage}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          
        </div>

        {/* Update Status Modal */}
        {s.showStatusModal && (
          <Modal
            title="Update POP Status"
            closeAction={this.closeStatusModal}
            footerContent={
              <>
                {s.valid && (
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={s.loading}
                    form="statusUpdateForm"
                  >
                    Update Status
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.closeStatusModal}
                >
                  Cancel
                </button>
              </>
            }
          >
            <form
              id="statusUpdateForm"
              onSubmit={this.handleStatusUpdate}
              className="mb-3"
              autoComplete="off"
            >
              {divMsg}
              <div className="bg-light p-4 rounded-3">
                <h4 className="fw-medium mb-2">POP Details</h4>
                <p>
                  <strong>Company:</strong> {s.selectedPop?.companyName}
                </p>
                <p>
                  <strong>POP File ID:</strong> {s.selectedPop?.popFileId}
                </p>
                <p>
                  <strong>Current Status:</strong> {s.selectedPop?.popStatus}
                </p>
              </div>

              <div className="row">
                <div className="col">
                  <div className="input-group">
                    <label className="input-group-text required">
                      New Status
                    </label>
                    <select
                      name="selectedStatus"
                      className={`form-control ${
                        s.errors.selectedStatus ? " !border-red-500" : ""
                      }`}
                      value={s.selectedStatus}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select Status</option>
                      {s.availableStatuses.map((status) => (
                        <option key={status} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>
                    {s.errors.selectedStatus && (
                      <span className="input-group-error">
                        {s.errors.selectedStatus}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col">
                  <div className="input-group">
                    <label className="input-group-text">Message</label>
                    <input
                      name="selectedMessage"
                      className={`form-control ${
                        s.errors.selectedMessage ? " !border-red-500" : ""
                      }`}
                      value={s.selectedMessage}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.selectedMessage && (
                      <span className="input-group-error">
                        {s.errors.selectedMessage}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </Modal>
        )}
      </div>
    );
  }
}
